import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { LocalizedDateFromUtc, Parenthesized } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedProperty } from '@mews/framework';
import { Stack, Typography } from '@optimus-web/core';
import { getFullName } from '@mews-commander/utils';
import { AddDocumentsButton } from '../AddDocumentsButton';
import { DOCUMENTS_RESERVATION_EXTENT } from '../constants';
import { useDocumentsTableContext } from './DocumentsTableContext';

export const DocumentsTableHead = () => {
    const enterpriseId = useCurrentEnterpriseId();
    const { groupId, reservationId } = useDocumentsTableContext();
    const { data: reservationData } = useRepositorySuspenseQuery('reservations', 'getAll', {
        groupIds: [groupId],
        extent: DOCUMENTS_RESERVATION_EXTENT,
    });

    const groupServiceIds = reservationData.reservations?.map((reservation) => reservation.serviceId);

    const { data: serviceData } = useRepositorySuspenseQuery('services', 'getAll', {
        serviceIds: groupServiceIds,
        enterpriseIds: [enterpriseId],
    });

    const reservation = reservationData.reservations?.find((r) => r.id === reservationId);

    if (reservation == null) {
        throw new Error('Reservation not found');
    }

    const account = reservationData.accounts?.find((a) => a.id === reservation.accountId);
    const { startUtc, endUtc, number } = reservation;
    const serviceName = serviceData.services.find((service) => service.id === reservation.serviceId)?.names;
    const fullName = getFullName(account);
    return (
        <Stack distribution="space-between" spacing="200" wrap>
            <Stack vertical spacing="100">
                <Typography textStyle="titleSmallStrong" as="h2">
                    {fullName}
                </Typography>
                <Typography textStyle="bodyMedium" variant="secondary" as="div">
                    {serviceName != null && <LocalizedProperty property={serviceName} />}
                    {UnicodeEntity.NoBreakSpace}
                    {number}
                    {UnicodeEntity.NoBreakSpace}
                    <Parenthesized>
                        <LocalizedDateFromUtc utcString={startUtc} />
                        {UnicodeEntity.NoBreakSpace}
                        {UnicodeEntity.Dash}
                        {UnicodeEntity.NoBreakSpace}
                        <LocalizedDateFromUtc utcString={endUtc} />
                    </Parenthesized>
                </Typography>
            </Stack>
            <AddDocumentsButton />
        </Stack>
    );
};
